
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TestCaseService } from '@app/testcase/testcase.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-suite-result',
  templateUrl: './suite-result.component.html',
  styleUrls: ['./suite-result.component.less']
})
export class SuiteResultComponent  {

  readonly ENTITY_MASTERSUITE = 'MASTERSUITE';
  readonly ENTITY_TESTSUITE = 'TESTSUITE';

  entities: any;
  entityExecutions: any;
  collectionSize: number;
  entityExecutionDetails: any = {};
  entityExecutionResults: any = {};
  testDataSequenceList: any;
  selectedExecutionDetails: any;
  selectedExecutionData: any;
  selectedExecutionDetailsIndex: any;
  selectedExecutionDataId: any;
  showPrevious = false;
  showNext = false;
  showGraph = false;
  retryArray: any = [];
  selectedRetryAttempt: any;

  @Input() entityType;
  @Input() projectConfiguration;
  @Input() set entityExecDetails(value: any) {
    this.entityExecutionDetails = value;
    this.initialiseEntity(value);
  }
  get entityExecDetails(): any {
    return this.entityExecutionDetails;
  }

  @Input() set entityExecResults(value: any) {
    if(value !== undefined && value !== null) {
      this.selectedRetryAttempt = value.reTryAttempt;
      this.setRetryArray(value.reTryAttempt);
    }
    this.entityExecutionResults = value;
    this.setTestDataSequenceList(value);
    this.initialiseEntityResults(value);
  }
  get entityExecResults(): any {
    return this.entityExecutionResults;
  }

  @Input() childEntityExec: any;
  @Input() childEntityResult: any;
  @Input() parallelRun: boolean;

  @Output() readEntityExecution = new EventEmitter<string>();
  @Output() readChildEntityExecution = new EventEmitter<string>();

  activeIndex: string;
  entityIndex = 0;

  // BootStrap flag
  closeErrorAlert = false;

  // Pagination
  page = 1;
  pageSize = 15;
  warningFlag = true;
  @Input() showPagination = false;
  @Output() selectedPage: EventEmitter<any> = new EventEmitter();
  @Output() selectedPageSize: EventEmitter<any> = new EventEmitter();

  constructor(private testCaseService: TestCaseService, private route: ActivatedRoute) { }

  testSuiteInfo = this.route.snapshot.data['details'].response

  showMobileTCVideo(testCaseExecution) {
        if (this.testSuiteInfo.mobileTestSuite) {
          window.open(
            `${environment.apiUrl}video/streamVideo?platform=mobile&fileName=${testCaseExecution.execution.noSqlId}.mp4`
          );
        } else if (this.testSuiteInfo.desktopTestSuite) {
          window.open(
            `${environment.apiUrl}video/streamVideo?platform=desktop&fileName=${testCaseExecution.execution.noSqlId}.mp4`
          );
        }
  }

  setTestDataSequenceList(data) {
    if (this.entityType === this.ENTITY_TESTSUITE && data) {
      if (
        data !== null &&
        data !== undefined &&
        data.testCaseExecutions !== null
      ) {
        let tempTestDataSequenceList = [];
        for (let i = 0; i < data.testCaseExecutions.length; i++) {
          let tempObject = {
            id: data.testCaseExecutions[i].noSqlId,
            testDataSequenceNumber:
              data.testCaseExecutions[i].testDataSetOrder === 0
                ? "Primary" + " - " + data.testCaseExecutions[i].executionStatus
                : "Secondary-" +
                  i +
                  " - " +
                  data.testCaseExecutions[i].executionStatus,
            index: i,
          };
          let mergedObject = {
            ...tempObject,
            ...data.testCaseExecutions[i],
          };
          tempTestDataSequenceList.push(mergedObject);
        }
        this.showPrevious = false;
        this.showNext = true;
        this.testDataSequenceList = tempTestDataSequenceList;
        this.getExecutionDetails(this.testDataSequenceList[0]);
        this.selectedExecutionData = this.testDataSequenceList[0];
        this.selectedExecutionDataId = this.testDataSequenceList[0].id;
      } else {
        this.selectedExecutionDetails = null;
        this.testDataSequenceList = [];
        this.selectedExecutionData = null;
        this.selectedExecutionDataId = null;
      }
    } else if (this.entityType === this.ENTITY_MASTERSUITE && data) {
      // this.collectionSize = value.count;
      // this.entities = value.testSuites;
      // this.activeIndex = value.testSuites[0].id;
    }
  }

  getExecutionDetails(execution: any) {
    if(execution !== undefined){
      this.selectedExecutionDetails = null;
      this.selectedExecutionDetailsIndex = execution.index;
      if(execution.index === 0) {
        this.showPrevious = false;
      } else {
        this.showPrevious = true;
      }
      if(execution.index + 1 === this.testDataSequenceList.length){
        this.showNext = false;
      } else {
        this.showNext = true;
      }
      this.selectedExecutionData = execution;
      this.testCaseService.getExecutionDetails(execution.id, this.selectedRetryAttempt).subscribe((data) => {
        if (data.code === 200) {
          this.selectedExecutionDetails = data.response;
          this.showGraph = false;
        } else {
          // this.tostr.info(data.message);
        }
      });
    } else {
      this.selectedExecutionDetails = null;
    }
  }

  initialiseEntity(value): void {
    if (this.entityType === this.ENTITY_TESTSUITE && value) {
      this.collectionSize = value.count;
      this.entities = value.testCases;
      if (!this.activeIndex) {
        this.activeIndex = value.testCases[0].noSqlId;
      }
    } else if (this.entityType === this.ENTITY_MASTERSUITE && value) {
      this.collectionSize = value.count;
      this.entities = value.testSuites;
      this.activeIndex = value.testSuites[0].id;
    }
  }

  initialiseEntityResults(value: any): void {
    if (this.entityType === this.ENTITY_TESTSUITE && value) {
      if (value.noSqlId) this.activeIndex = value.noSqlId;
      this.entityExecutions = value.testCaseExecutions;
    } else if (this.entityType === this.ENTITY_MASTERSUITE && value) {
      this.entityExecutions = value;
    }
  }

  getStatusColor(status: any) {
    if(status === 'PASSED') {
      return 'success-style'
    } else if(status === 'FAILED') {
      return 'failure-style'
    } else if(status === 'ABORTED') {
      return 'aborted-style'
    } else if(status === 'PAUSED ') {
      return 'paused-style'
    }else if(status === 'SKIPPED') {
      return 'skipped-style'
    }
  }

  previousTestData() {
    this.selectedExecutionDetails = null;
    this.selectedExecutionData = this.testDataSequenceList[this.selectedExecutionData.index - 1] ;
    this.selectedExecutionDataId = this.selectedExecutionData.id;
    this.selectedExecutionDetailsIndex = this.selectedExecutionData.index;
    if(this.selectedExecutionData.index === 0) {
      this.showPrevious = false;
    } else {
      this.showPrevious = true;
    }
    if(this.selectedExecutionData.index + 1 === this.testDataSequenceList.length){
      this.showNext = false;
    } else {
      this.showNext = true;
    }
    this.testCaseService.getExecutionDetails(this.selectedExecutionData.id, this.selectedRetryAttempt).subscribe((data) => {
      if (data.code === 200) {
        this.selectedExecutionDetails = data.response;
        this.showGraph = false;
      } else {
        // this.tostr.info(data.message);
      }
    });
  }

  nextTestData() {
    this.selectedExecutionDetails = null;
    this.selectedExecutionData = this.testDataSequenceList[this.selectedExecutionData.index + 1] ;
    this.selectedExecutionDataId = this.selectedExecutionData.id;
    this.selectedExecutionDetailsIndex = this.selectedExecutionData.index;
    if(this.selectedExecutionData.index === 0) {
      this.showPrevious = false;
    } else {
      this.showPrevious = true;
    }
    if(this.selectedExecutionData.index + 1 === this.testDataSequenceList.length){
      this.showNext = false;
    } else {
      this.showNext = true;
    }
    this.testCaseService.getExecutionDetails(this.selectedExecutionData.id, this.selectedRetryAttempt).subscribe((data) => {
      if (data.code === 200) {
        this.selectedExecutionDetails = data.response;
        this.showGraph = false;
      } else {
        // this.tostr.info(data.message);
      }
    });
  }

  readEntityExecutionDetails(noSqlId: string, tabIndex: number): void {
    this.activeIndex = noSqlId;
    this.selectedRetryAttempt = -1;
    this.readEntityExecution.emit(noSqlId);
    this.entityIndex = tabIndex;
    this.showGraph = false;
  }

  readChildEntityExecutionDetails(noSqlId: string): void {
    this.readChildEntityExecution.emit(noSqlId);
  }

  showGraphSection(testSuiteInfo, entityExecutionResults, selectedExecutionData) {
    if(this.entityType === this.ENTITY_TESTSUITE) {
      if((selectedExecutionData?.desktopTestCase || selectedExecutionData?.mobileTestCase) && (selectedExecutionData?.executionStatus !== 'IN_PROGRESS' && selectedExecutionData?.executionStatus !== 'PENDING')) {
        return true;
      }
    }
  }

  setRetryArray(reTryAttempt: any) {
    this.retryArray = [];
    for(let i = 0; i <= reTryAttempt; i++) {
      this.retryArray.push({
        id: i,
        name: i
      });
    }
  }

  /* Pagination Section */
  onSizeChange(pageSize) {
    this.pageSize = pageSize;
    this.selectedPageSize.emit(pageSize);
  }

  onPageChange(page) {
    this.page = page;
    this.selectedPage.emit(page);
  }
}
